import { TimeFrameId } from '@givelify/utils';

export const mapTimeFrameId = (timeFrameId: TimeFrameId): string => {
    const map: Partial<{ [K in TimeFrameId]: string }> = {
        today: 'today',
        yesterday: 'yesterday',
        thisWeek: 'this_week',
        lastWeek: 'last_week',
        thisMonth: 'this_month',
        lastMonth: 'last_month',
        thisYear: 'this_year',
        lastYear: 'last_year',
    };

    return map[timeFrameId] ? map[timeFrameId] : timeFrameId;
};
